import { Pipe, PipeTransform } from '@angular/core';

export function toSpacedEventType(eventType: string): string {
  if (!eventType) {
    return '';
  }
  return eventType.replace(/([A-Z])/g, ' $1').trim();
}

@Pipe({
  name: 'eventType'
})
export class EventTypePipe implements PipeTransform {
  transform(eventType: string): string {
    return toSpacedEventType(eventType);
  }
} 